import { afterEvent, defineGameCard } from '../authoring/index.js';
import { isSlimeDefinitionId, SLIME_RESIDUE_ID, slimeSetDependencies, trail, } from './slime-helpers.js';
export const RoyalJellyCard = defineGameCard({
    id: 'royal_jelly',
    gameplay: {
        type: 'UNIT', cost: 4,
        baseStats: { attack: 1, health: 5 }, traits: ['SLIME'],
    },
    presentation: {
        name: 'Королевское желе',
        description: 'След 2. Когда один или несколько других ваших слизней поглощены, получает половину их суммарной атаки и здоровья.',
        glyph: {
            colors: ['#10213A', '#FCA215', '#FFC42C', '#ED790D', '#B74510'],
            rows: [
                '....................',
                '....................',
                '......11.11.11......',
                '......12133121......',
                '......14233241......',
                '......14233241......',
                '.....1422222441.....',
                '....123333332241....',
                '...12355533322441...',
                '..1525515333122441..',
                '..1253555332224441..',
                '..1422223222244441..',
                '.144322222224454441.',
                '14243223224445554441',
                '12333222444452244441',
                '12333222222442244441',
                '14222233332244444551',
                '14222333334422255551',
                '.111111111111111111.',
                '....................',
            ],
        },
    },
    role: 'playable',
    dependencies: slimeSetDependencies(SLIME_RESIDUE_ID),
    abilities: [
        trail(2),
        afterEvent({
            event: 'CardsAbsorbed',
            when(ctx, event) {
                const self = ctx.self;
                return self !== undefined && event.donors.some((donor) => donor.instanceId !== self.id
                    && donor.controllerId === self.controllerId
                    && isSlimeDefinitionId(donor.defId));
            },
            run(ctx, event) {
                const self = ctx.self;
                if (self === undefined)
                    return;
                const donors = event.donors.filter((donor) => donor.instanceId !== self.id
                    && donor.controllerId === self.controllerId
                    && isSlimeDefinitionId(donor.defId));
                const attack = Math.floor(donors.reduce((sum, donor) => sum + donor.stats.attack, 0) / 2);
                const health = Math.floor(donors.reduce((sum, donor) => sum + Math.max(0, donor.stats.health), 0) / 2);
                if (attack > 0)
                    ctx.ops.modifyStat(self.id, 'attack', attack, self.id);
                if (health > 0) {
                    ctx.ops.modifyStat(self.id, 'maxHealth', health, self.id);
                    ctx.ops.modifyStat(self.id, 'health', health, self.id);
                }
            },
        }),
    ],
    ui: { mechanics: ['trail', 'slime_residue', 'absorb'] },
});
//# sourceMappingURL=royal_jelly.js.map